exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ag-datacenter .ag-header-cell:not(.ag-header-cell-sortable) .ag-header-cell-label{cursor:default}.ag-datacenter .ag-header-cell-label .ag-header-cell-text{font-size:14px;font-weight:700;line-height:18px}.ag-datacenter .ag-cell.ag-cell-last-left-pinned{border-right:2px solid #ccc}.ag-datacenter.print .ag-header-icon{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./app/components/table/ng-theme-overrides.scss
// module id = 312
// module chunks = 1